import { FunctionCallState } from '../types'

export const FUNCTION_CALL_MESSAGES: Record<string, string> = {
  get_current_date_time: 'Getting current date and time…',
  update_name: 'Updating your name…',
  generate_document_template: 'Creating your document…',
  fill_single_field: 'Filling in field…',
  display_payment_widget: 'Setting up payment…',
  get_blog_post_content_user_is_reading: 'Loading blog content…',
  get_consumer_cases: 'Loading your cases…',
  default: 'Processing your request…',
}

export const THINKING_MESSAGE = 'Thinking…'

export function getFunctionCallMessage(
  functionName: string,
  functionCallState: FunctionCallState,
  customProgressMessage?: string
): string {
  if (customProgressMessage?.trim() && customProgressMessage !== 'Thinking...') {
    return customProgressMessage
  }

  const isExecutingState =
    functionCallState === FunctionCallState.Pending ||
    functionCallState === FunctionCallState.Executing

  return isExecutingState
    ? FUNCTION_CALL_MESSAGES[functionName] || FUNCTION_CALL_MESSAGES.default
    : ''
}

export function getLoadingMessage(
  functionName?: string,
  functionCallState?: FunctionCallState,
  customProgressMessage?: string
): string {
  if (functionName && functionCallState) {
    const functionMessage = getFunctionCallMessage(
      functionName,
      functionCallState,
      customProgressMessage
    )
    if (functionMessage) return functionMessage
  }

  return THINKING_MESSAGE
}

export function getCompletionMessage(functionName: string): string {
  const formattedName = functionName
    .replace(/_/g, ' ')
    .replace(/\b\w/g, letter => letter.toUpperCase())

  return `${formattedName} completed successfully`
}
